import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { ArticlesServices } from '../../services';
import { Globals } from '../../../../globals';
import { ProductCreateWfoodcostInfoPage } from '../../../products/product-create/product-create-without-foodcost/product-create-wfoodcost-info/product-create-wfoodcost-info';
import { DishCreateNamePage } from '../../../dish/dish-create/dish-create-name/dish-create-name';

/**
 * Generated class for the ArticlesCreateTypePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-articles-create-type',
  templateUrl: 'articles-create-type.html',
})
export class ArticlesCreateTypePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public articlesServices: ArticlesServices) {

  }

  createProduct() {
    this.navCtrl.push(ProductCreateWfoodcostInfoPage, {
      update_state: false
    });
  }

  createDish() {
    this.navCtrl.push(DishCreateNamePage, {
      update: false
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/articles/articles-create/articles-create-type/articles-create-type.ts